// Portfolio page specific marker - helps verify correct page loading
console.log('=== PORTFOLIO PAGE LOADED SUCCESSFULLY ===');
console.log('Portfolio.js loaded - Pinterest Style Masonry Layout');

import gsap from 'gsap';

// Add import for the portfolio data
let portfolioData = [];

// Load portfolio data from JSON file
async function loadPortfolioData() {
    try {
        // Improved path detection for different environments
        const hostname = window.location.hostname;
        const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
        const isDev = isLocalhost || window.location.port === '3000' || window.location.port === '4173'; 

        // Try multiple paths in sequence until one works
        const possiblePaths = [
            isDev ? '/src/data/portfolio-data.json' : '/data/portfolio-data.json',  // Absolute path
            '../data/portfolio-data.json',                                          // Relative path from pages dir
            '/data/portfolio-data.json',                                            // Absolute from root 
            'data/portfolio-data.json'                                              // Relative from current dir
        ];

        console.log('Fetching portfolio data, will try these paths:', possiblePaths);
        console.log('Current hostname:', window.location.hostname);
        console.log('Current port:', window.location.port);
        console.log('Current path:', window.location.pathname);
        
        // Try each path until one works
        let response = null;
        let successPath = null;
        
        for (const path of possiblePaths) {
            try {
                console.log('Trying to fetch from:', path);
                const resp = await fetch(path);
                if (resp.ok) {
                    response = resp;
                    successPath = path;
                    console.log('Successfully fetched data from:', path);
                    break;
                } else {
                    console.log(`Path ${path} returned status: ${resp.status}`);
                }
            } catch (pathError) {
                console.log(`Error trying path ${path}:`, pathError.message);
            }
        }
        
        if (!response) {
            throw new Error('All data paths failed');
        }
        
        portfolioData = await response.json();
        console.log(`Loaded portfolio data from ${successPath}:`, portfolioData);
        
        // Sort projects by order field
        portfolioData.sort((a, b) => a.order - b.order);
        
        // Process image paths for Vite compatibility
        portfolioData.forEach(project => {
            console.log('Processing project:', project.title);
            // Handle image paths
            if (project.imageUrl) {
                console.log('Project image URL:', project.imageUrl);
                // If it's a local asset (starts with /assets/), use it as is
                // If it's an external URL (starts with http), use it as is
                // No need to modify the paths anymore since we're using the correct format
            }
            
            // Process dynamic objects images
            if (project.dynamicObjects) {
                console.log('Processing dynamic objects for:', project.title);
                project.dynamicObjects.forEach(obj => {
                    if (obj.type === 'picture' && obj.imageUrl) {
                        console.log('Dynamic object image URL:', obj.imageUrl);
                        // Same handling as above - use paths as is
                    }
                });
            }
            
            // Calculate aspect ratios for projects that don't have them explicitly defined
            if (!project.aspectRatio) {
                console.log('Calculating aspect ratio for:', project.title);
                // Create a temporary image to calculate aspect ratio from the image dimensions
                const img = new Image();
                img.src = project.imageUrl;
                
                // Default aspect ratio until image loads
                project.aspectRatio = 1;
                
                // Update aspect ratio when image loads
                img.onload = function() {
                    project.aspectRatio = this.width / this.height;
                    console.log('Aspect ratio calculated for:', project.title, ':', project.aspectRatio);
                    // Trigger layout update if masonry is already initialized
                    if (document.querySelector('.masonry-container')) {
                        initMasonryLayout();
                    }
                };
            }
        });
        
        // Initialize portfolio after data is loaded
        console.log('Initializing portfolio with processed data');
        initPortfolioSafely();
    } catch (error) {
        console.error('Error loading portfolio data:', error);
        
        // Try alternate path as fallback
        try {
            console.log('Attempting fallback data loading path...');
            const fallbackPath = '/data/portfolio-data.json';
            if (fallbackPath !== dataPath) {
                const fallbackResponse = await fetch(fallbackPath);
                if (!fallbackResponse.ok) {
                    throw new Error(`Fallback also failed: ${fallbackResponse.status}`);
                }
                portfolioData = await fallbackResponse.json();
                console.log('Loaded portfolio data from fallback path:', portfolioData);
                portfolioData.sort((a, b) => a.order - b.order);
                initPortfolioSafely();
                return;
            }
        } catch (fallbackError) {
            console.error('Fallback data loading also failed:', fallbackError);
        }
        
        // Final fallback to default initialization
        initPortfolioSafely();
    }
}

// Immediately apply critical fixes for mobile menu
(function fixMobileMenu() {
    // Apply this fix immediately to prevent menu from disappearing
    const style = document.createElement('style');
    style.id = 'critical-menu-fix';
    style.textContent = `
        /* CRITICAL: Prevent mobile menu from disappearing */
        .mobile-menu-button, 
        .header-right,
        .fixed-header .header-right,
        .fixed-header .mobile-menu-button {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            z-index: 999999 !important;
            position: absolute !important;
            right: 20px !important;
            top: 15px !important;
            pointer-events: auto !important;
        }
        
        /* Mobile-specific header adjustments (matching home page) */
        @media (max-width: 800px) {
            .fixed-header {
                padding-top: 0px !important;
            }
            
            .mobile-menu-button, 
            .header-right,
            .fixed-header .header-right,
            .fixed-header .mobile-menu-button {
                top: 20px !important;
            }
            
            /* Align PORTFOLIO text with hamburger */
            .fixed-header .header-content {
                padding-top: 0px !important;
            }
            
            /* MOBILE ADJUSTMENT POINT 1: Adjust this value to move the PORTFOLIO text up/down on mobile */
            .fixed-header .header-title {
                margin-top: 10px !important; /* TUNE THIS VALUE for mobile alignment */
            }
        }
    `;
    document.head.appendChild(style);
    
    // Set up a continuous check to ensure menu stays visible
    const ensureMenuVisible = () => {
        const menuButton = document.querySelector('.mobile-menu-button');
        const headerRight = document.querySelector('.header-right');
        
        if (menuButton) {
            menuButton.style.display = 'block';
            menuButton.style.visibility = 'visible';
            menuButton.style.opacity = '1';
            menuButton.style.zIndex = '999999';
            menuButton.style.pointerEvents = 'auto';
            
            // Adjust position on mobile - match home page positioning
            if (window.innerWidth <= 800) {
                menuButton.style.top = '20px';
            } else {
                menuButton.style.top = '15px'; // Unchanged for desktop
            }
        }
        
        if (headerRight) {
            headerRight.style.display = 'block';
            headerRight.style.visibility = 'visible';
            headerRight.style.opacity = '1';
            headerRight.style.zIndex = '999999';
            headerRight.style.position = 'absolute';
            headerRight.style.right = '20px';
            
            // Adjust position on mobile - match home page positioning
            if (window.innerWidth <= 800) {
                headerRight.style.top = '20px';
            } else {
                headerRight.style.top = '15px'; // Unchanged for desktop
            }
            
            headerRight.style.pointerEvents = 'auto';
        }
    };
    
    // Run immediately
    ensureMenuVisible();
    
    // Set up a repeating check
    setInterval(ensureMenuVisible, 500);
    
    // Also run check on any DOM changes
    const observer = new MutationObserver(ensureMenuVisible);
    observer.observe(document.documentElement, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
    });
    
    // And run after a delay to catch late changes
    setTimeout(ensureMenuVisible, 100);
    setTimeout(ensureMenuVisible, 500);
    setTimeout(ensureMenuVisible, 1000);
    
    // Handle resize events
    window.addEventListener('resize', ensureMenuVisible);
})();

// DOM Elements
document.querySelector('.mobile-menu-button')?.addEventListener('click', function() {
    this.classList.toggle('active');
    document.querySelector('.mobile-nav')?.classList.toggle('active');
    
    // Ensure the button stays visible even after click
    this.style.display = 'block';
    this.style.visibility = 'visible';
    this.style.opacity = '1';
});

// Close menu when clicking a link or outside
document.querySelectorAll('.mobile-nav-list a').forEach(link => {
    link.addEventListener('click', function() {
        document.querySelector('.mobile-menu-button').classList.remove('active');
        document.querySelector('.mobile-nav').classList.remove('active');
    });
});

document.addEventListener('click', function(e) {
    const mobileNav = document.querySelector('.mobile-nav');
    const menuButton = document.querySelector('.mobile-menu-button');
    if (mobileNav?.classList.contains('active') && 
        !mobileNav.contains(e.target) && 
        !menuButton.contains(e.target)) {
        menuButton.classList.remove('active');
        mobileNav.classList.remove('active');
    }
});

// Define category color mappings
const categoryColors = {
    'Viz': {
        gradient: ['#C98B4F', '#BEA264']  // More muted, toned down orange-yellow gradient
    },
    'Code': {
        gradient: ['#4776E6', '#42A5F5']  // More vibrant, neon blue gradient
    },
    'Art': {
        gradient: ['#8E2DE2', '#4A00E0']
    },
    'Music': {
        gradient: ['#1D976C', '#93F9B9']
    },
    'data': {
        gradient: ['#4776E6', '#42A5F5']  // Using the same blue gradient as Code for data visualizations
    },
    // Default gradient for any other categories
    'default': {
        gradient: ['#333333', '#222222']
    }
};

// Helper function to get category colors
function getCategoryColors(category) {
    return categoryColors[category] || categoryColors['default'];
}

// Initialize portfolio when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM loaded, initializing portfolio');
    // Load portfolio data from JSON
    loadPortfolioData();
    
    // Expose initMasonryLayout to window for ResizeObserver
    window.initMasonryLayout = initMasonryLayout;
    
    // Setup header effects
    setupHeaderEffects();
});

// Preload images before layout is calculated
function preloadProjectImages() {
    portfolioData.forEach(project => {
        const img = new Image();
        img.src = project.imageUrl;
        
        // Also preload any images in dynamicObjects
        if (project.dynamicObjects) {
            project.dynamicObjects.forEach(obj => {
                if (obj.type === 'picture' && obj.imageUrl) {
                    const imgObj = new Image();
                    imgObj.src = obj.imageUrl;
                }
            });
        }
    });
}

// Safe initialization with proper cleanup and checks
function initPortfolioSafely() {
    console.log('Starting safe portfolio initialization');
    
    // Clear any pending timeouts
    if (window.portfolioInitTimeout) {
        clearTimeout(window.portfolioInitTimeout);
    }
    
    // Simple initialization without unnecessary delays or checks
    try {
        initPortfolio();
    } catch (error) {
        console.error('Error during portfolio initialization:', error);
        showFallbackLayout();
    }
}

// MASONRY LAYOUT IMPLEMENTATION
function initPortfolio() {
    try {
        const container = document.getElementById('scene-container');
        if (!container) {
            console.error('Portfolio container element not found!');
            return;
        }
        
        console.log('Initializing portfolio with container:', container);
        
        // Clear any existing content
        container.innerHTML = '';
        
        // Add masonry styles
        addStyles();
        
        // Find the header element (the one containing PORTFOLIO text)
        const headerElement = document.querySelector('.fixed-header');
        
        // Create category filters for the header
        const filtersContainer = document.createElement('div');
        filtersContainer.className = 'category-filters';
        
        // Add filter buttons
        createCategoryFilters(filtersContainer);
        
        // Insert the filters into the header or right after it if found
        if (headerElement) {
            // Check if headerElement already has the filter
            const existingFilter = headerElement.querySelector('.category-filters');
            if (existingFilter) {
                existingFilter.remove();
            }
            
            // Add the filter to the header
            headerElement.appendChild(filtersContainer);
            
            // Adjust header and filter styles for better integration
            filtersContainer.style.marginTop = '0';
            filtersContainer.style.position = 'absolute';
            filtersContainer.style.bottom = '0';
            filtersContainer.style.left = '0';
            filtersContainer.style.width = '100%';
            filtersContainer.style.borderTop = '1px solid rgba(255,255,255,0.1)';
            filtersContainer.style.borderBottom = 'none';
            filtersContainer.style.zIndex = '100'; // Ensure it's below the hamburger menu
        } else {
            // If header not found, insert at top of container
            container.insertBefore(filtersContainer, container.firstChild);
        }
        
        // Create masonry container
        const masonryContainer = document.createElement('div');
        masonryContainer.className = 'masonry-container';
        container.appendChild(masonryContainer);
        
        // Make sure portfolioData is sorted by order
        portfolioData.sort((a, b) => a.order - b.order);
        
        // Create project cards
        portfolioData.forEach((project, index) => {
            createProjectCard(project, index, masonryContainer);
        });
        
        // Initialize masonry layout immediately
        initMasonryLayout();
        console.log('Masonry layout initialized');
        
        // Add scroll indicator
        addScrollIndicator();
        
        // Add window resize listener with a short debounce
        const resizeHandler = debounce(() => {
            console.log('Window resized, reinitializing masonry layout');
            try {
                initMasonryLayout();
            } catch (error) {
                console.error('Error during resize handling:', error);
                recoverLayout();
            }
        }, 100); // Shorter debounce time for more responsive layout
        
        // Remove any existing resize listeners to avoid duplication
        window.removeEventListener('resize', resizeHandler);
        window.addEventListener('resize', resizeHandler);
        
        // Add final safety check for layout in case images load slowly
        setTimeout(() => {
            // Check if layout looks correct, otherwise reinitialize
            const columns = document.querySelectorAll('.masonry-column');
            if (!columns.length || columns.length < 2) {
                console.warn('Columns missing after initialization, attempting recovery');
                initMasonryLayout();
            }
        }, 1000);
    } catch (error) {
        console.error('Error initializing portfolio:', error);
        // Attempt recovery by showing a simple fallback layout
        showFallbackLayout();
    }
}

function addStyles() {
    // Remove any existing portfolio styles
    const existingStyles = document.getElementById('masonry-styles');
    if (existingStyles) {
        existingStyles.remove();
    }
    
    // Create style element
    const style = document.createElement('style');
    style.id = 'masonry-styles';
    style.textContent = `
        @keyframes diamondShimmer {
            0%, 100% { opacity: var(--base-opacity); background-color: rgba(255, 255, 255, var(--base-opacity)); }
            50% { opacity: var(--shimmer-opacity); background-color: rgba(255, 255, 255, var(--shimmer-opacity)); }
        }
        
        .project-card {
            position: relative;
            overflow: hidden;
        }
        
        /* Base diamond polygon styles */
        .project-card .diamond-polygon {
            position: absolute;
            background-color: rgba(255, 255, 255, 0.02);
            /* Create a proper diamond shape that's taller than wide */
            clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
            width: 40px;
            height: 80px;
            z-index: 0;
            pointer-events: none;
            /* Create the dark lines between diamonds through box-shadow instead of borders */
            box-shadow: 0 0 0 1px rgba(0,0,0,0.02);
            border: none;
        }
        
        /* Shimmer effect for selected diamonds */
        .project-card .diamond-polygon.shimmer {
            animation: diamondShimmer var(--shimmer-duration) ease-in-out infinite;
            animation-delay: var(--shimmer-delay);
        }
        
        .card-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.4);
            pointer-events: none;
            transition: background-color 0.3s ease;
            border-radius: 6px;
            z-index: 0;
        }
        
        .project-card-content {
            position: relative;
            z-index: 2;
        }
        
        /* Custom scrollbar styling for all scrollable elements */
        .container, .expanded-content {
            /* Firefox */
            scrollbar-width: thin;
            scrollbar-color: rgba(100, 100, 100, 0.5) rgba(30, 30, 30, 0.3);
        }
        
        /* Webkit browsers (Chrome, Safari, Edge) */
        .container::-webkit-scrollbar, .expanded-content::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
        
        .container::-webkit-scrollbar-track, .expanded-content::-webkit-scrollbar-track {
            background: rgba(30, 30, 30, 0.3);
            border-radius: 4px;
        }
        
        .container::-webkit-scrollbar-thumb, .expanded-content::-webkit-scrollbar-thumb {
            background: rgba(100, 100, 100, 0.5);
            border-radius: 4px;
        }
        
        .container::-webkit-scrollbar-thumb:hover, .expanded-content::-webkit-scrollbar-thumb:hover {
            background: rgba(120, 120, 120, 0.7);
        }
        
        .category-filters {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin: 0;
            padding: 10px 0;
            background-color: rgba(20,20,20,0.7);
            position: relative;
            z-index: 100;
            backdrop-filter: blur(5px);
            width: 100%;
        }
        
        .fixed-header .category-filters {
            position: absolute;
            bottom: 0;
            left: 0;
            border-top: 1px solid rgba(255,255,255,0.1);
            border-bottom: none;
        }
        
        .category-filter {
            padding: 6px 14px;
            background-color: transparent;
            border: 1px solid rgba(255,255,255,0.2);
            border-radius: 4px;
            color: rgba(255,255,255,0.7);
            font-family: 'Montserrat', sans-serif;
            font-size: 12px;
            text-transform: uppercase;
            cursor: pointer;
            transition: all 0.3s ease;
            letter-spacing: 0.5px;
        }
        
        /* Style category filters with their specific colors */
        .category-filter[data-category="Viz"] {
            border-color: ${categoryColors['Viz'].gradient[0]};
        }
        
        .category-filter[data-category="Code"] {
            border-color: ${categoryColors['Code'].gradient[0]};
        }
        
        .category-filter[data-category="Art"] {
            border-color: ${categoryColors['Art'].gradient[0]};
        }
        
        .category-filter[data-category="Music"] {
            border-color: ${categoryColors['Music'].gradient[0]};
        }
        
        .category-filter:hover {
            background-color: rgba(255,255,255,0.05);
            color: white;
        }
        
        /* Active state for category filters */
        .category-filter.active[data-category="All"] {
            background-color: rgba(255,255,255,0.1);
            color: white;
            border-color: rgba(255,255,255,0.4);
            box-shadow: 0 0 10px rgba(255,255,255,0.1);
        }
        
        .category-filter.active[data-category="Viz"] {
            background-color: ${categoryColors['Viz'].gradient[0]};
            color: white;
            box-shadow: 0 0 10px ${categoryColors['Viz'].gradient[0]};
        }
        
        .category-filter.active[data-category="Code"] {
            background-color: ${categoryColors['Code'].gradient[0]};
            color: white;
            box-shadow: 0 0 10px ${categoryColors['Code'].gradient[0]};
        }
        
        .category-filter.active[data-category="Art"] {
            background-color: ${categoryColors['Art'].gradient[0]};
            color: white;
            box-shadow: 0 0 10px ${categoryColors['Art'].gradient[0]};
        }
        
        .category-filter.active[data-category="Music"] {
            background-color: ${categoryColors['Music'].gradient[0]};
            color: white;
            box-shadow: 0 0 10px ${categoryColors['Music'].gradient[0]};
        }
    `;
    
    // Generate category-specific CSS by appending to style
    for (const category in categoryColors) {
        if (category !== 'default') {
            const catStyle = `
                .category-filter[data-category="${category}"] {
                    border-color: ${categoryColors[category].gradient[0]};
                }
                
                .category-filter.active[data-category="${category}"] {
                    background-color: ${categoryColors[category].gradient[0]};
                    color: white;
                    box-shadow: 0 0 10px ${categoryColors[category].gradient[0]};
                }
            `;
            style.textContent += catStyle;
        }
    }
    
    // Append rest of the styles
    style.textContent += `
        .masonry-container {
            padding: 30px;
            padding-top: 40px;
            padding-bottom: 120px;
            padding-left: 1px;
            padding-right: 1px;
            box-sizing: border-box;
            position: relative;
            margin: 0 auto;
            max-width: 1600px;
            overflow: visible;
            min-height: calc(100vh - 150px);
            margin-top: 20px;
        }
        
        .category-tag {
            padding: 4px 10px;
            border-radius: 4px;
            color: rgba(255,255,255,0.8);
            font-family: 'Montserrat', sans-serif;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            display: inline-block;
            margin-top: 10px;
            background-color: transparent;
            border: 1px solid rgba(255,255,255,0.3);
        }
        
        /* Styles for clickable pictures in dynamic objects list */
        .expanded-content .dynamic-picture {
            position: relative;
            overflow: hidden;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            cursor: pointer;
            border-radius: 4px;
        }
        
        .expanded-content .dynamic-picture::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.3);
            opacity: 0;
            transition: opacity 0.3s ease;
            z-index: 1;
            border-radius: 4px;
        }
        
        .expanded-content .dynamic-picture::after {
            content: '🔍';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.8);
            color: white;
            font-size: 24px;
            opacity: 0;
            transition: opacity 0.3s ease, transform 0.3s ease;
            z-index: 2;
        }
        
        .expanded-content .dynamic-picture:hover {
            transform: scale(1.02);
            box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        }
        
        .expanded-content .dynamic-picture:hover::before {
            opacity: 1;
        }
        
        .expanded-content .dynamic-picture:hover::after {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
        
        .masonry-column {
            position: absolute;
            top: 0;
            padding: 0;
            padding-left: 0; /* Remove left padding */
            padding-right: 10px; /* Reduced spacing between columns */
            box-sizing: border-box;
            transition: left 0.3s ease;
            will-change: transform; /* Optimization for GPU acceleration */
        }
        
        .project-card {
            width: 100%;
            margin-bottom: 20px;
            border-radius: 6px;
            overflow: hidden;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            box-shadow: 0 5px 15px rgba(0,0,0,0.2);
            cursor: pointer;
            position: relative;
            background: linear-gradient(to bottom, #333, #222);
            opacity: 1 !important; /* Make card fully opaque to avoid compound transparency */
            border: 1px solid rgba(150,150,150,0.3); /* Add grey outline to cards */
        }
        
        .card-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            pointer-events: none;
            transition: background-color 0.3s ease;
            border-radius: 6px;
            z-index: 0; /* Change from 1 to 0 so content appears above */
        }
        
        .project-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 12px 24px rgba(0,0,0,0.3);
        }
        
        .project-card:hover .project-card-content {
            background-color: rgba(255,255,255,0.05);
        }
        
        .project-card-content {
            padding: 25px;
            box-sizing: border-box;
            transition: background-color 0.3s ease, opacity 0.3s ease;
            position: relative;
            z-index: 1; /* Ensure content is above the overlay */
            opacity: 0.85; /* Reduced transparency for content */
        }
        
        .project-card:hover .project-card-content {
            background-color: rgba(255,255,255,0.05);
            opacity: 1; /* Full opacity on hover */
        }
        
        .project-image {
            display: block;
            width: 100%;
            height: auto;
            margin-bottom: 15px;
            border-radius: 4px;
            transition: transform 0.3s ease, opacity 0.3s ease;
            opacity: 0.6; /* Increase transparency significantly */
        }
        
        .project-card:hover .project-image {
            transform: scale(1.02);
            opacity: 1; /* Full opacity on hover */
        }
        
        .project-card h3 {
            margin: 0 0 12px 0;
            color: rgba(255,255,255,0.85);
            font-family: 'Montserrat', sans-serif;
            font-size: 20px;
            font-weight: 500;
            line-height: 1.3;
            letter-spacing: 1.5px;
            transition: opacity 0.3s ease;
        }
        
        .project-card:hover h3 {
            color: rgba(255,255,255,1);
        }
        
        .project-card .divider {
            width: 50px;
            height: 2px;
            background-color: rgba(255,255,255,0.2);
            margin-bottom: 15px;
            transition: width 0.3s ease, background-color 0.3s ease, opacity 0.3s ease;
        }
        
        .project-card:hover .divider {
            width: 70px;
            background-color: rgba(255,255,255,0.4);
        }
        
        .project-card p {
            color: rgba(255,255,255,0.7);
            font-family: 'Montserrat', sans-serif;
            font-size: 14px;
            line-height: 1.6;
            margin: 0 0 25px 0;
            transition: color 0.3s ease, opacity 0.3s ease;
        }
        
        .project-card:hover p {
            color: rgba(255,255,255,0.9);
        }
        
        .card-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .project-card .button {
            display: inline-block;
            padding: 8px 16px;
            background-color: transparent;
            border: 1px solid rgba(255,255,255,0.3);
            border-radius: 4px;
            color: white;
            font-family: 'Montserrat', sans-serif;
            font-size: 12px;
            text-transform: uppercase;
            transition: all 0.3s ease;
            letter-spacing: 0.5px;
            opacity: 0.85; /* Reduced transparency for buttons */
        }
        
        .project-card:hover .button {
            background-color: rgba(255,255,255,0.1);
            border-color: rgba(255,255,255,0.5);
            opacity: 1;
        }
        
        .project-card .category-tag {
            opacity: 0.85; /* Reduced transparency for category tags */
            transition: opacity 0.3s ease;
        }
        
        .project-card:hover .category-tag {
            opacity: 1;
        }
        
        /* Ensure any canvas elements don't block our content */
        canvas {
            pointer-events: none;
        }
        
        /* Override any conflicting styles */
        #mobius-canvas, #scene-container canvas {
            z-index: 0 !important;
        }
        
        .expanded-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.9);
            z-index: 1000000;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.4s ease;
            backdrop-filter: blur(5px);
        }
        
        .expanded-overlay.active {
            opacity: 1;
            pointer-events: auto;
        }
        
        .expanded-content {
            width: 80%;
            max-width: 900px;
            max-height: 85vh;
            overflow: auto;
            background: linear-gradient(135deg, #272727, #1a1a1a);
            border-radius: 6px;
            padding: 40px;
            position: relative;
            transform: scale(0.95) translateY(20px);
            transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1);
            box-shadow: 0 15px 35px rgba(0,0,0,0.4);
        }
        
        .expanded-overlay.active .expanded-content {
            transform: scale(1) translateY(0);
        }
        
        .close-button {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: rgba(60,60,60,0.7);
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
        }
        
        .close-button:hover {
            background-color: rgba(80,80,80,0.9);
            transform: rotate(90deg);
        }
        
        .close-button::before,
        .close-button::after {
            content: '';
            position: absolute;
            width: 20px;
            height: 2px;
            background-color: white;
            transition: background-color 0.3s ease;
        }
        
        .close-button:hover::before,
        .close-button:hover::after {
            background-color: #fff;
        }
        
        .close-button::before {
            transform: rotate(45deg);
        }
        
        .close-button::after {
            transform: rotate(-45deg);
        }
        
        .scroll-indicator {
            position: fixed;
            bottom: 20px;
            right: 20px;
            opacity: 0.5;
            z-index: 100;
            animation: pulse 2s infinite;
            pointer-events: none;
            filter: drop-shadow(0 0 5px rgba(0,0,0,0.5));
            transition: opacity 0.3s, visibility 0.3s;
        }
        
        @keyframes pulse {
            0% { opacity: 0.5; transform: translateY(0); }
            50% { opacity: 0.8; transform: translateY(5px); }
            100% { opacity: 0.5; transform: translateY(0); }
        }
        
        .scroll-indicator.hidden {
            opacity: 0;
            visibility: hidden;
        }
        
        /* Add subtle animations for cards */
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 0.5; }
        }
        
        .project-card {
            animation: none; /* Disable the animation so we can control opacity directly */
            opacity: 0.5 !important;
        }
        
        /* Disable animations during filtering to prevent glitches */
        .filtering .project-card {
            animation: none !important;
            opacity: 1 !important;
            transform: none !important;
        }
        
        /* For filtered cards */
        .project-card.hidden {
            display: none;
        }
        
        /* CRITICAL FIX: Force desktop spacing to be correct */
        @media (min-width: 801px) {
            #scene-container {
                padding-top: 10px !important;
            }
            
            .masonry-container, 
            .masonry-container[style] {
                padding-top: 10px !important;
                margin-top: 10px !important;
            }
            
            .masonry-column,
            .masonry-column[style] {
                top: 10px !important;
            }
        }
        
        @media (max-width: 800px) {
            .masonry-container {
                padding: 15px;
                padding-top: 80px !important; /* CRITICAL: Extra space below header on mobile */
                padding-left: 1px; /* Set to 1px as requested */
                padding-right: 1px; /* Set to 1px as requested */
                margin-top: 30px !important; /* CRITICAL: Add significant margin */
            }
            
            /* Critical fix for column positioning on mobile */
            .masonry-column {
                padding-top: 30px !important; /* Add padding to columns as well */
                padding-right: 8px; /* Reduce column spacing on smaller screens */
            }
            
            /* Reduce vertical spacing between cards on mobile */
            .project-card {
                margin-bottom: 15px; /* Slightly increased from 12px, but still less than original 20px */
            }
            
            .project-card-content {
                padding: 20px;
            }
            
            .project-card h3 {
                font-size: 18px;
            }
            
            .category-filters {
                flex-wrap: wrap;
                gap: 10px;
                padding: 8px 0;
            }
            
            .category-filter {
                padding: 5px 10px;
                font-size: 11px;
            }
        }
        
        @media (max-width: 600px) {
            .masonry-container {
                padding: 10px;
                padding-top: 80px !important; /* CRITICAL: Extra space below header on mobile */
                padding-left: 1px; /* Set to 1px as requested */
                padding-right: 1px; /* Set to 1px as requested */
                margin-top: 30px !important; /* CRITICAL: Add significant margin */
            }
            
            .project-card-content {
                padding: 12px;
            }
            
            .project-card h3 {
                font-size: 14px;
                margin-bottom: 8px;
            }
            
            .project-card p {
                font-size: 12px;
                line-height: 1.4;
                margin-bottom: 15px;
            }
            
            .project-card .button {
                padding: 6px 12px;
                font-size: 10px;
            }
            
            .project-card .divider {
                margin-bottom: 10px;
            }
            
            .expanded-content {
                width: 95%;
                padding: 20px;
            }
            
            .masonry-column {
                padding-top: 30px !important; /* Add padding to columns as well */
                padding-right: 6px; /* Further reduce column spacing on very small screens */
            }
            
            .category-tag {
                font-size: 9px;
                padding: 3px 6px;
            }
        }
        
        /* Extra small screens need further reduction */
        @media (max-width: 400px) {
            .project-card-content {
                padding: 10px;
            }
            
            .project-card h3 {
                font-size: 13px;
                margin-bottom: 6px;
            }
            
            .project-card .divider {
                margin-bottom: 8px;
            }
            
            .project-card p {
                font-size: 11px;
                margin-bottom: 12px;
            }
            
            .masonry-column {
                padding-right: 5px; /* Minimal spacing for tiny screens */
            }
            
            .category-filters {
                gap: 5px;
                padding: 8px 5px;
            }
            
            .category-filter {
                padding: 4px 8px;
                font-size: 10px;
            }
        }

        /* CRITICAL FIX: Force mobile spacing to be correct */
        @media (max-width: 800px) {
            #scene-container {
                padding-top: 0px !important;
            }
            
            .masonry-container, 
            .masonry-container[style] {
                padding-top: 10px !important;
                margin-top: 10px !important;
            }
            
            .masonry-column,
            .masonry-column[style] {
                top: 10px !important;
            }
        }
    `;
    
    document.head.appendChild(style);
}

function createProjectCard(project, index, container) {
    console.log('Creating card for project:', project.title);
    const card = document.createElement('div');
    card.className = 'project-card';
    card.dataset.index = index;
    card.dataset.category = project.category;
    card.style.setProperty('--card-index', index); // For staggered animation
    
    // Get colors based on category
    const categoryStyle = getCategoryColors(project.category);
    console.log('Category style for', project.category, ':', categoryStyle);
    
    // Apply gradient background based on category
    card.style.background = `linear-gradient(to bottom, ${categoryStyle.gradient[0]}, ${categoryStyle.gradient[1]})`;
    
    // Create overlay - this handles card background transparency
    const overlay = document.createElement('div');
    overlay.className = 'card-overlay';
    card.appendChild(overlay);
    
    // Create diamond pattern with tall polygons
    // Set up diamond dimensions and spacing
    const diamondWidth = 40;
    const diamondHeight = 80;
    
    // Define spacing with a buffer between diamonds
    const gap = 2; // Gap between diamonds (reduced from 6px)
    const horizontalSpacing = diamondWidth + gap;
    // Vertical spacing between rows needs to account for diamond geometry
    const rowHeight = diamondHeight / 2 + gap/2;
    
    // Add the diamond pattern after the card is added to the DOM
    // This allows us to get the actual card dimensions
    setTimeout(() => {
        // Get actual card dimensions
        const cardWidth = card.offsetWidth;
        const cardHeight = card.offsetHeight;
        
        if (cardWidth && cardHeight) {
            // Calculate how many diamonds we need to cover the card with no gaps
            const cols = Math.ceil(cardWidth / (diamondWidth + gap)) + 1; // +1 for partial diamonds at edges
            const rows = Math.ceil(cardHeight / rowHeight) + 1; // +1 for partial diamonds at edges
            
            console.log(`Creating diamond pattern: ${rows} rows x ${cols} cols for card size ${cardWidth}x${cardHeight}`);
            
            // Remove any existing diamonds
            card.querySelectorAll('.diamond-polygon').forEach(el => el.remove());
            
            // Create the diamond pattern with proper offsets
            for (let row = -1; row <= rows; row++) {
                const isOddRow = row % 2 !== 0;
                
                // Calculate horizontal offset for this row
                // Odd rows are shifted to create interlocking pattern
                const rowXOffset = isOddRow ? horizontalSpacing / 2 : 0;
                
                for (let col = -1; col <= cols; col++) {
                    const diamond = document.createElement('div');
                    diamond.className = 'diamond-polygon';
                    
                    // Calculate position with proper spacing
                    const xPos = col * horizontalSpacing + rowXOffset;
                    const yPos = row * rowHeight;
                    
                    diamond.style.left = `${xPos}px`;
                    diamond.style.top = `${yPos}px`;
                    
                    // Add subtle variation in shading (slightly increased opacity)
                    const opacity = 0.007 + Math.random() * 0.013;
                    diamond.style.backgroundColor = `rgba(255, 255, 255, ${opacity})`;
                    
                    // Randomly add shimmer effect to about 15% of diamonds
                    if (Math.random() < 0.15) {
                        diamond.classList.add('shimmer');
                        
                        // Set custom shimmer properties
                        const baseOpacity = opacity;
                        // Shimmer makes the diamond briefly glow brighter (slightly increased intensity)
                        const shimmerOpacity = baseOpacity * 3 + 0.03;
                        
                        // Random duration and delay for shimmer
                        const shimmerDuration = 3 + Math.random() * 7 + 's'; // 3-10s
                        const shimmerDelay = Math.random() * 15 + 's'; // 0-15s delay
                        
                        diamond.style.setProperty('--base-opacity', baseOpacity);
                        diamond.style.setProperty('--shimmer-opacity', shimmerOpacity);
                        diamond.style.setProperty('--shimmer-duration', shimmerDuration);
                        diamond.style.setProperty('--shimmer-delay', shimmerDelay);
                    }
                    
                    card.appendChild(diamond);
                }
            }
        }
    }, 100); // Short delay to ensure card is in the DOM
    
    // Create content container - this handles content transparency independently
    const content = document.createElement('div');
    content.className = 'project-card-content';
    
    // Set card height based on aspect ratio (calculated later in masonry layout)
    card.dataset.aspectRatio = project.aspectRatio || 1;
    
    // Add title
    const title = document.createElement('h3');
    title.textContent = project.title;
    content.appendChild(title);
    
    // Add divider
    const divider = document.createElement('div');
    divider.className = 'divider';
    content.appendChild(divider);
    
    // Add image with proper Vite asset handling
    const image = document.createElement('img');
    image.className = 'project-image';
    
    // Use the image URL as is - Vite will handle the resolution
    image.src = project.imageUrl;
    
    image.alt = project.title;
    image.style.width = '100%';
    image.style.height = 'auto';
    image.style.marginBottom = '15px';
    image.style.display = 'block';
    image.style.borderRadius = '4px';
    image.style.filter = 'opacity(95%)'; // Increase transparency (up from 70%)
    image.style.transition = 'filter 0.3s ease, transform 0.3s ease'; // Add transition for filter
    
    // Add decoding and loading attributes for better performance
    image.decoding = 'async';
    image.loading = 'eager'; // Ensure images load as soon as possible
    
    content.appendChild(image);
    
    // Add description
    const description = document.createElement('p');
    description.innerHTML = project.description.replace(/\n/g, '<br>');
    content.appendChild(description);
    
    // Add category tag
    const categoryTag = document.createElement('div');
    categoryTag.className = 'category-tag';
    categoryTag.textContent = project.category;
    categoryTag.style.display = 'inline-block';
    categoryTag.style.marginTop = '10px';
    categoryTag.dataset.category = project.category;
    content.appendChild(categoryTag);
    
    // Add content to card (above overlay in the DOM, but below visually due to z-index)
    card.appendChild(content);
    
    // Add hover events for transparency control
    card.addEventListener('mouseenter', () => {
        overlay.style.backgroundColor = 'rgba(0,0,0,0.1)';
        content.style.opacity = '1';
        image.style.filter = 'opacity(100%)'; // Full opacity on hover
    });
    
    card.addEventListener('mouseleave', () => {
        overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
        content.style.opacity = '0.85';
        image.style.filter = 'opacity(95%)'; // Less transparency (up from 40%)
    });
    
    container.appendChild(card);
    console.log('Card created and appended to container');
    
    // Add click event
    card.addEventListener('click', () => expandProject(project));
    
    // Add load event to the image to recalculate layout after image loads
    image.addEventListener('load', () => {
        console.log('Image loaded for:', project.title);
        // Find the column this card belongs to
        const column = card.closest('.masonry-column');
        if (column) {
            // Trigger a layout recalculation
            updateColumnHeights(Array.from(document.querySelectorAll('.masonry-column')).map(col => ({
                element: col,
                height: 0
            })), document.querySelector('.masonry-container'));
        }
    });
}

function initMasonryLayout() {
    try {
        const container = document.querySelector('.masonry-container');
        if (!container) {
            console.error('Masonry container not found');
            return;
        }
        
        // Account for header offset in scroll calculations
        const headerHeight = document.querySelector('.fixed-header')?.offsetHeight || 100;
        
        // Adjust padding based on device width
        if (window.innerWidth <= 800) {
            // Mobile - use more padding to account for taller header
            container.style.paddingTop = '60px';
            container.style.marginTop = '30px';
        } else {
            // Desktop - use original values
            container.style.paddingTop = '40px';
            container.style.marginTop = '20px';
        }
        
        // Store existing cards before removing columns
        const existingCards = Array.from(container.querySelectorAll('.project-card'));
        
        // Create a temporary container to hold cards during layout reconstruction
        const tempContainer = document.createElement('div');
        tempContainer.style.display = 'none';
        document.body.appendChild(tempContainer);
        
        // Move existing cards to temp container to preserve them
        existingCards.forEach(card => {
            tempContainer.appendChild(card);
        });
        
        // Remove existing columns
        container.querySelectorAll('.masonry-column').forEach(col => col.remove());
        
        // If we have no cards but they should exist, ensure they're recreated
        if (existingCards.length === 0 && portfolioData.length > 0) {
            console.log('No existing cards found, recreating them');
            portfolioData.forEach((project, index) => {
                createProjectCard(project, index, tempContainer);
            });
        }
        
        // Get container width
        const containerWidth = container.offsetWidth;
        if (!containerWidth) {
            console.error('Container has zero width, aborting layout');
            // Return cards to main container before exiting
            Array.from(tempContainer.querySelectorAll('.project-card')).forEach(card => {
                container.appendChild(card);
            });
            document.body.removeChild(tempContainer);
            return;
        }
        
        console.log('Container width:', containerWidth);
        
        // Determine number of columns based ONLY on container width
        // - NOT limiting by card count, always use the maximum appropriate number of columns
        let numColumns;
        if (containerWidth > 1800) {
            numColumns = 7;
        } else if (containerWidth > 1600) {
            numColumns = 6;
        } else if (containerWidth > 1300) {
            numColumns = 5;
        } else if (containerWidth > 1000) {
            numColumns = 4;
        } else if (containerWidth > 800) {
            numColumns = 3;
        } else {
            numColumns = 2;
        }
        
        // Ensure at least 1 column
        numColumns = Math.max(1, numColumns);
        
        // Calculate column width (accounting for padding)
        const padding = 10; // Reduced padding to match visual spacing
        const leftPadding = 1; // Set to 1px as requested
        
        // Right padding changes based on screen size
        let rightPadding = 1; // Set to 1px as requested
        if (window.innerWidth <= 600) {
            rightPadding = 1; // Consistent 1px padding across all screen sizes
        }
        
        // Adjust padding between columns for very small screens
        const columnPadding = window.innerWidth <= 800 ? 10 : padding;
        
        // Calculate total horizontal space taken by padding
        const colPadding = columnPadding * (numColumns - 1); // Space between columns
        const containerPadding = leftPadding + rightPadding; // Container padding
        
        // Calculate available width for columns after all padding
        const availableWidth = containerWidth - colPadding - containerPadding;
        const columnWidth = Math.floor(availableWidth / numColumns);
        
        console.log('Layout calculation:', {
            containerWidth,
            numColumns,
            availableWidth,
            columnWidth,
            totalWidth: (columnWidth * numColumns) + colPadding + containerPadding
        });
        
        // Create columns
        const columns = [];
        for (let i = 0; i < numColumns; i++) {
            const column = document.createElement('div');
            column.className = 'masonry-column';
            column.style.width = `${columnWidth}px`;
            
            // Position columns with proper left offset (account for container's left padding)
            const columnLeft = leftPadding + (i * (columnWidth + columnPadding));
            
            // Add safety check to ensure the rightmost column doesn't overflow
            if (i === numColumns - 1) {
                // For the last column, verify it doesn't overflow
                const rightEdge = columnLeft + columnWidth + rightPadding;
                if (rightEdge > containerWidth) {
                    // If it would overflow, reduce the width to fit
                    const adjustedWidth = containerWidth - columnLeft - rightPadding;
                    column.style.width = `${adjustedWidth}px`;
                    console.log('Adjusted last column width to prevent overflow:', adjustedWidth);
                }
            }
            
            column.style.left = `${columnLeft}px`;
            container.appendChild(column);
            columns.push({
                element: column,
                height: 0
            });
        }
        
        // Get all cards from the temporary container
        const cards = Array.from(tempContainer.querySelectorAll('.project-card'));
        
        // Sort cards by project order
        cards.sort((a, b) => {
            const aIndex = parseInt(a.dataset.index);
            const bIndex = parseInt(b.dataset.index);
            const aProject = portfolioData[aIndex];
            const bProject = portfolioData[bIndex];
            return aProject.order - bProject.order;
        });
        
        // Distribute cards into columns - left to right, top to bottom
        // This ensures proper distribution across all available columns
        cards.forEach((card, index) => {
            // Place each card in the appropriate column (left to right)
            const columnIndex = index % numColumns;
            const column = columns[columnIndex];
            
            // Add card to column
            column.element.appendChild(card);
            
            // Estimate card height - initially use a fixed height based on image aspect ratio
            const project = portfolioData[parseInt(card.dataset.index) || 0];
            const imageAspect = project.aspectRatio || 1;
            const imageHeight = Math.floor(columnWidth / imageAspect);
            const estimatedCardHeight = imageHeight + 150; // Image height + space for text and padding
            
            // Update column height with our estimate
            column.height += estimatedCardHeight + padding;
        });
        
        // Now set up observers to adjust layout after images load
        const imageObserver = new ResizeObserver(() => {
            // Recalculate column heights based on actual content
            setTimeout(() => {
                updateColumnHeights(columns, container);
            }, 100);
        });
        
        // Observe each card's image
        cards.forEach(card => {
            const image = card.querySelector('.project-image');
            if (image) {
                image.onload = () => {
                    updateColumnHeights(columns, container);
                };
                imageObserver.observe(image);
            }
        });
        
        // Initial column height update
        updateColumnHeights(columns, container);
        
        // Remove the temporary container
        document.body.removeChild(tempContainer);
        
        console.log('Masonry layout completed with', numColumns, 'columns');
    } catch (error) {
        console.error('Error in masonry layout:', error);
        // If an error occurs, attempt to restore the layout
        recoverLayout();
    }
}

// Helper function to update column heights
function updateColumnHeights(columns, container) {
    try {
        if (!container || !columns || !columns.length) {
            console.error('Missing container or columns for height update');
            return;
        }
        
        // Reset column heights
        columns.forEach(column => {
            column.height = 0;
            
            // Calculate actual height
            const cards = Array.from(column.element.querySelectorAll('.project-card'));
            cards.forEach(card => {
                // Use actual offsetHeight now that images might be loaded
                // Use smaller gap on mobile screens
                const gap = window.innerWidth <= 800 ? 10 : 15; // 10px gap for mobile (increased from 8px), 15px for desktop
                column.height += card.offsetHeight + gap; // card height + gap
            });
        });
        
        // Find tallest column
        const tallestColumn = columns.reduce((prev, curr) => 
            prev.height > curr.height ? prev : curr, 
            { height: 0 }
        );
        
        // Set container height 
        const containerHeight = tallestColumn.height + 200; // Add padding
        container.style.height = `${containerHeight}px`;
        
        // Add a bottom spacer element to ensure scrollability
        const existingSpacer = container.querySelector('.bottom-spacer');
        if (!existingSpacer) {
            const spacer = document.createElement('div');
            spacer.className = 'bottom-spacer';
            spacer.style.height = '100px';
            spacer.style.width = '100%';
            spacer.style.clear = 'both';
            container.appendChild(spacer);
        }
        
        // Ensure content is scrollable
        const mainContainer = document.querySelector('.container');
        if (mainContainer) {
            // If container height is less than viewport, add extra space
            const viewportHeight = window.innerHeight - 100; // Viewport minus header
            if (containerHeight < viewportHeight) {
                container.style.height = `${viewportHeight + 300}px`;
            }
        }
        
        console.log('Column heights updated');
    } catch (error) {
        console.error('Error updating column heights:', error);
    }
}

// Add a recovery function to restore layout if something goes wrong
function recoverLayout() {
    console.log('Attempting to recover layout');
    const container = document.querySelector('.masonry-container');
    if (!container) return;
    
    // Check if we have cards - if not, recreate them
    const cards = container.querySelectorAll('.project-card');
    if (cards.length === 0) {
        console.log('No cards found, recreating from projects data');
        // Clear container first
        container.innerHTML = '';
        
        // Create cards
        portfolioData.forEach((project, index) => {
            createProjectCard(project, index, container);
        });
        
        // Simple layout as fallback
        setTimeout(() => {
            initMasonryLayout();
        }, 50);
    }
}

function expandProject(project) {
    // Create or get overlay
    let overlay = document.querySelector('.expanded-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'expanded-overlay';
        document.body.appendChild(overlay);
    }
    
    // Get color gradient based on category (only for category tag styling)
    const categoryStyle = getCategoryColors(project.category);
    
    // Create expanded content with consistent dark grey gradient background
    const content = document.createElement('div');
    content.className = 'expanded-content';
    content.style.background = `linear-gradient(to bottom, #333333, #222222)`; // Fixed dark grey gradient
    
    // Start building the inner HTML for content
    let contentHTML = `
        <h2 style="font-family: 'Montserrat', sans-serif; color: white; font-size: 24px; letter-spacing: 2px; font-weight: 500; margin: 0 0 20px 0; text-transform: none; padding-right: 70px; text-align: left;">${project.title}</h2>
        <div style="width: 60px; height: 2px; background-color: rgba(255,255,255,0.2); margin-bottom: 30px;"></div>
        
        <!-- Two-column layout for image and description -->
        <div style="display: flex; gap: 30px; margin-bottom: 30px; flex-wrap: wrap;">
            <!-- Left column for image (40% width) -->
            <div style="flex: 0 0 40%; min-width: 200px;">
                <img src="${project.imageUrl}" alt="${project.title}" style="width: 100%; height: auto; border-radius: 4px;">
            </div>
            
            <!-- Right column for description (60% width) -->
            <div style="flex: 1; min-width: 250px;">
                <p style="font-family: 'Montserrat', sans-serif; color: rgba(255,255,255,0.9); font-size: 16px; line-height: 1.6; margin: 0;">${project.description.replace(/\n/g, '<br>')}</p>
            </div>
        </div>
        
        <div style="font-family: 'Montserrat', sans-serif; color: rgba(255,255,255,0.9); font-size: 16px; line-height: 1.6;">
            <h3 style="font-size: 20px; margin: 0 0 15px 0; color: white;">Project Details</h3>
            <p style="margin-bottom: 25px;">
                ${project.projectDetails.replace(/\n/g, '<br>')}
            </p>
    `;
    
    // Add dynamic objects from the project configuration
    if (project.dynamicObjects && project.dynamicObjects.length > 0) {
        contentHTML += `
            <div style="display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 30px; justify-content: space-between;">
        `;
        
        // Process each dynamic object
        project.dynamicObjects.forEach(obj => {
            if (obj.type === 'textPanel') {
                // Create text panel with better mobile responsiveness
                contentHTML += `
                    <div style="flex: 0 1 calc(50% - 8px); min-width: 120px; max-width: 100%; background-color: rgba(255,255,255,0.1); padding: 15px; border-radius: 6px; margin-bottom: 16px; box-sizing: border-box;">
                        <h4 style="font-size: 16px; margin: 0 0 8px 0; color: white;">${obj.title}</h4>
                        <ul style="margin: 0; padding-left: 16px; color: rgba(255,255,255,0.8); font-size: 14px;">
                            ${obj.content.map(item => `<li style="margin-bottom: 4px;">${item}</li>`).join('')}
                        </ul>
                    </div>
                `;
            } else if (obj.type === 'picture') {
                // Create picture element with consistent sizing
                contentHTML += `
                    <div style="flex: 0 1 calc(50% - 8px); min-width: 120px; max-width: 100%; margin-bottom: 16px; box-sizing: border-box;">
                        <div style="position: relative;">
                            <img src="${obj.imageUrl}" alt="${obj.alt || 'Project image'}" 
                                 class="dynamic-picture"
                                 style="width: 100%; height: auto; border-radius: 4px; cursor: pointer;"
                                 onclick="showFullScreenImage('${obj.imageUrl}')">
                            ${obj.description ? `<p style="margin: 8px 0 0 0; font-size: 13px; color: rgba(255,255,255,0.7); font-style: italic;">${obj.description}</p>` : ''}
                        </div>
                    </div>
                `;
            } else if (obj.type === 'audio') {
                // Create audio element with enhanced styling and controls - full width
                contentHTML += `
                    <div style="flex: 0 0 100%; width: 100%; margin-bottom: 16px; box-sizing: border-box;">
                        <div style="position: relative; background-color: rgba(255,255,255,0.1); padding: 15px; border-radius: 6px;">
                            <style>
                                /* Basic styling for the audio element */
                                .custom-audio {
                                    width: 100%;
                                    outline: none;
                                    border-radius: 4px;
                                    -webkit-appearance: none;
                                    appearance: none;
                                }
                                
                                /* Progress bar styling - light grey background for all states except actual playback */
                                .custom-audio::-webkit-media-slider-container,
                                .custom-audio::-webkit-slider-runnable-track,
                                .custom-audio::-moz-range-track,
                                .custom-audio::-ms-fill-upper,
                                .custom-audio::-webkit-progress-bar {
                                    background-color: rgba(255,255,255,0.2) !important;
                                }
                                
                                /* Progress indicator styling - dark grey */
                                .custom-audio::-webkit-media-slider-thumb,
                                .custom-audio::-webkit-slider-thumb,
                                .custom-audio::-moz-range-thumb {
                                    background-color: #444 !important;
                                }
                                
                                /* Played portion - dark grey */
                                .custom-audio::-webkit-progress-value,
                                .custom-audio::-moz-range-progress,
                                .custom-audio::-ms-fill-lower {
                                    background-color: #444 !important;
                                }
                                
                                /* Ensure buffer indicators match unplayed state */
                                .custom-audio::-webkit-media-slider-container > div,
                                .custom-audio::-webkit-media-slider-container > div > div,
                                .custom-audio::after,
                                .custom-audio::-webkit-media-controls-timeline-container,
                                .custom-audio::-webkit-media-controls-timeline,
                                .custom-audio::-webkit-media-controls-current-time-display,
                                .custom-audio::-webkit-media-controls-time-remaining-display,
                                .custom-audio::-webkit-media-controls-timeline::before,
                                .custom-audio::-webkit-media-controls-timeline::after,
                                .custom-audio::-webkit-media-controls-panel {
                                    background-color: rgba(255,255,255,0.2) !important;
                                }
                                
                                /* Specific override for Chrome's buffered progress indicator */
                                .custom-audio::-webkit-media-controls-timeline::-webkit-media-controls-timeline-buffered {
                                    background-color: rgba(255,255,255,0.2) !important;
                                }
                                
                                @media (max-width: 500px) {
                                    .custom-audio::-webkit-media-controls-enclosure {
                                        max-height: 32px;
                                    }
                                }
                            </style>
                            <audio controls preload="metadata" class="custom-audio" style="width: 100%; outline: none; border-radius: 4px;">
                                <source src="${obj.audioUrl}" type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>
                            ${obj.description ? `<p style="margin: 8px 0 0 0; font-size: 13px; color: rgba(255,255,255,0.7); font-style: italic;">${obj.description}</p>` : ''}
                        </div>
                    </div>
                `;
            }
        });
        
        contentHTML += `</div>`;
    }
    
    // Add link button and category tag
    contentHTML += `
            <div style="text-align: center; margin-top: 20px;">
                ${project.linkButton ? `<a href="${project.linkButton.url}" target="_blank" class="button" style="display: inline-block; padding: 10px 20px; border: 1px solid rgba(255,255,255,0.3); border-radius: 4px; color: white; cursor: pointer; font-size: 14px; margin-bottom: 10px; text-transform: none; text-decoration: none;">${project.linkButton.text}</a>` : ''}
                <br>
                <div class="category-tag" data-category="${project.category}" style="margin-top: 10px; background-color: transparent; border: 1px solid ${categoryStyle.gradient[0]}; color: ${categoryStyle.gradient[0]};">${project.category}</div>
            </div>
        </div>
    `;
    
    // Set the content HTML
    content.innerHTML = contentHTML;
    
    // Add close button
    const closeButton = document.createElement('div');
    closeButton.className = 'close-button';
    closeButton.addEventListener('click', () => {
        overlay.classList.remove('active');
    });
    
    content.appendChild(closeButton);
    overlay.innerHTML = '';
    overlay.appendChild(content);
    
    // Show overlay
    requestAnimationFrame(() => {
        overlay.classList.add('active');
    });
    
    // Close on overlay click (not content)
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
            overlay.classList.remove('active');
        }
    });
    
    // Close on escape key
    const escapeHandler = (e) => {
        if (e.key === 'Escape') {
            overlay.classList.remove('active');
            document.removeEventListener('keydown', escapeHandler);
        }
    };
    
    document.addEventListener('keydown', escapeHandler);
}

// Add full-screen image viewer functionality
window.showFullScreenImage = function(imageUrl) {
    // Create or get fullscreen overlay
    let fullscreenOverlay = document.querySelector('.fullscreen-image-overlay');
    if (!fullscreenOverlay) {
        fullscreenOverlay = document.createElement('div');
        fullscreenOverlay.className = 'fullscreen-image-overlay';
        document.body.appendChild(fullscreenOverlay);
        
        // Add click handler to close when clicking the overlay (but not the image)
        fullscreenOverlay.addEventListener('click', (e) => {
            if (e.target === fullscreenOverlay) {
                fullscreenOverlay.classList.remove('active');
                setTimeout(() => {
                    fullscreenOverlay.style.display = 'none';
                }, 300);
            }
        });
        
        // Add escape key handler
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && fullscreenOverlay.classList.contains('active')) {
                fullscreenOverlay.classList.remove('active');
                setTimeout(() => {
                    fullscreenOverlay.style.display = 'none';
                }, 300);
            }
        });
    }
    
    // Create image element
    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = 'Fullscreen view';
    
    // Create close button
    const closeButton = document.createElement('div');
    closeButton.className = 'fullscreen-image-close';
    closeButton.addEventListener('click', () => {
        fullscreenOverlay.classList.remove('active');
        setTimeout(() => {
            fullscreenOverlay.style.display = 'none';
        }, 300);
    });
    
    // Clear overlay content and add image and close button
    fullscreenOverlay.innerHTML = '';
    fullscreenOverlay.appendChild(img);
    fullscreenOverlay.appendChild(closeButton);
    
    // Show overlay
    fullscreenOverlay.style.display = 'flex';
    // Force reflow before adding active class for transition to work
    void fullscreenOverlay.offsetWidth;
    fullscreenOverlay.classList.add('active');
};

// Add scroll indicator
function addScrollIndicator() {
    // Remove existing indicator
    const existingIndicator = document.querySelector('.scroll-indicator');
    if (existingIndicator) {
        existingIndicator.remove();
    }
    
    // Remove existing style if present
    const existingStyle = document.getElementById('scroll-indicator-style');
    if (existingStyle) {
        existingStyle.remove();
    }
    
    // Create indicator
    const indicator = document.createElement('div');
    indicator.className = 'scroll-indicator';
    indicator.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7 13l5 5 5-5M7 6l5 5 5-5"/>
        </svg>
    `;
    
    document.body.appendChild(indicator);
    
    // Add spacer div at the bottom of content
    const container = document.querySelector('.masonry-container');
    if (container) {
        // Remove existing spacer if any
        const existingSpacer = container.querySelector('.bottom-spacer');
        if (existingSpacer) {
            existingSpacer.remove();
        }
        
        // Create a more substantial spacer
        const spacer = document.createElement('div');
        spacer.className = 'bottom-spacer';
        spacer.style.height = '200px'; // Even larger bottom spacer
        spacer.style.width = '100%';
        spacer.style.clear = 'both';
        spacer.style.marginTop = '50px';
        container.appendChild(spacer);
    }
    
    // Style the indicator - ensure it's properly positioned
    const style = document.createElement('style');
    style.id = 'scroll-indicator-style'; // Add ID for easy removal later
    style.textContent = `
        .scroll-indicator {
            position: fixed;
            bottom: 20px;
            right: 20px;
            opacity: 0.5;
            z-index: 100;
            animation: pulse 2s infinite;
            pointer-events: none;
            filter: drop-shadow(0 0 5px rgba(0,0,0,0.5));
            transition: opacity 0.3s, visibility 0.3s;
        }
        
        @keyframes pulse {
            0% { opacity: 0.5; transform: translateY(0); }
            50% { opacity: 0.8; transform: translateY(5px); }
            100% { opacity: 0.5; transform: translateY(0); }
        }

        .scroll-indicator.hidden {
            opacity: 0;
            visibility: hidden;
            display: none;
        }
    `;
    document.head.appendChild(style);
    
    // Track scroll on the main container element
    const mainContainer = document.querySelector('.container');
    if (mainContainer) {
        // Remove any existing scroll listeners
        const newScrollListener = function() {
            // Calculate whether we're near the bottom
            const scrollPosition = mainContainer.scrollTop + mainContainer.clientHeight;
            const scrollHeight = mainContainer.scrollHeight;
            
            // Only hide when very close to bottom (within 50px)
            if (scrollPosition > scrollHeight - 50) {
                indicator.classList.add('hidden');
            } else {
                indicator.classList.remove('hidden');
            }
        };
        
        // Add the new listener
        mainContainer.addEventListener('scroll', newScrollListener);

        // Initial check in case already at bottom
        setTimeout(newScrollListener, 200);
    }
}

function addSmoothScrolling(container) {
    // Add smooth scroll class to container
    container.classList.add('smooth-scroll');
    
    // Add smooth scroll styles if not already present
    if (!document.getElementById('smooth-scroll-styles')) {
        const style = document.createElement('style');
        style.id = 'smooth-scroll-styles';
        style.textContent = `
            .smooth-scroll {
                scroll-behavior: smooth;
            }
            
            @media (prefers-reduced-motion) {
                .smooth-scroll {
                    scroll-behavior: auto;
                }
            }
        `;
        document.head.appendChild(style);
    }
    
    // Set up intersection observer for lazy loading and animations
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, { 
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    
    // Observe all project cards
    document.querySelectorAll('.project-card').forEach(card => {
        observer.observe(card);
    });
}

// Handle window load event to ensure images are loaded before final layout
window.addEventListener('load', () => {
    console.log('Window fully loaded, ensuring layout is visible');
    
    // Force a re-layout after everything is loaded
    setTimeout(() => {
        const container = document.querySelector('.masonry-container');
        if (!container) {
            console.warn('Masonry container not found after window load, reinitializing portfolio');
            initPortfolioSafely();
            return;
        }
        
        // Check if container has actual visible content
        const cards = container.querySelectorAll('.project-card');
        if (cards.length === 0 || !container.offsetHeight || container.offsetHeight < 10) {
            console.warn('Container appears empty or hidden after window load, reinitializing layout');
            initMasonryLayout();
        } else {
            console.log('Layout appears correct after window load');
            // Still update column heights as final measure
            const columns = Array.from(container.querySelectorAll('.masonry-column')).map(col => ({
                element: col,
                height: 0
            }));
            updateColumnHeights(columns, container);
        }
    }, 300);
});

// Add page visibility change handler to recover from tab switches
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
        console.log('Page became visible, checking layout');
        
        // Add a safety check to verify if the layout is intact
        const checkLayout = () => {
            const container = document.querySelector('.masonry-container');
            if (!container) {
                console.warn('Container not found after visibility change');
                return;
            }
            
            const columns = container.querySelectorAll('.masonry-column');
            const cards = container.querySelectorAll('.project-card');
            
            // Check if the layout appears broken (no columns or cards)
            if (!columns.length || !cards.length || !container.offsetHeight || container.offsetHeight < 10) {
                console.warn('Layout appears broken after visibility change, reinitializing');
                // Try to recover layout with a delay to allow DOM to settle
                setTimeout(() => {
                    try {
                        initMasonryLayout();
                    } catch (error) {
                        console.error('Error recovering layout after visibility change:', error);
                        recoverLayout();
                    }
                }, 100);
            } else {
                console.log('Layout appears intact after visibility change');
            }
        };
        
        // Check layout after a short delay to allow rendering
        setTimeout(checkLayout, 200);
    }
});

// Ensure content is displayed even after browser resize, by adding a resize end detection
let resizeTimer;
window.addEventListener('resize', () => {
    // Clear the timeout if it's been set
    clearTimeout(resizeTimer);
    
    // Mark that we're currently resizing
    document.body.classList.add('resizing');
    
    // Set a timeout that will run after resize is complete
    resizeTimer = setTimeout(() => {
        document.body.classList.remove('resizing');
        console.log('Resize completed, verifying layout');
        
        // Check if layout is still visible
        const container = document.querySelector('.masonry-container');
        if (container) {
            const cards = container.querySelectorAll('.project-card');
            if (!cards.length || !container.offsetHeight || container.offsetHeight < 10) {
                console.warn('Layout appears broken after resize completion, reinitializing');
                recoverLayout();
            }
        }
    }, 250);
});

// Add specific styles for resize state to prevent flashing
const resizeStyle = document.createElement('style');
resizeStyle.textContent = `
    body.resizing .masonry-container {
        transition: none !important;
    }
    body.resizing .masonry-column {
        transition: none !important;
    }
`;
document.head.appendChild(resizeStyle);

// Add keyboard navigation for project cards
document.addEventListener('keydown', (e) => {
    // If Escape key is pressed and expanded overlay is visible, close it
    if (e.key === 'Escape') {
        const overlay = document.querySelector('.expanded-overlay.active');
        if (overlay) {
            overlay.classList.remove('active');
        }
    }
});

// Utility: Debounce function
function debounce(func, wait) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

// Fallback layout in case of errors
function showFallbackLayout() {
    const container = document.getElementById('scene-container');
    if (!container) return;
    
    container.innerHTML = '';
    container.style.overflow = 'auto';
    container.style.padding = '30px';
    
    const header = document.createElement('h2');
    header.textContent = 'Portfolio Projects';
    header.style.color = 'white';
    header.style.marginBottom = '30px';
    header.style.fontFamily = "'Montserrat', sans-serif";
    container.appendChild(header);
    
    portfolioData.forEach(project => {
        const card = document.createElement('div');
        card.style.backgroundColor = project.color;
        card.style.borderRadius = '8px';
        card.style.padding = '20px';
        card.style.marginBottom = '20px';
        card.style.color = 'white';
        card.style.fontFamily = "'Montserrat', sans-serif";
        
        const title = document.createElement('h3');
        title.textContent = project.title;
        title.style.marginBottom = '10px';
        
        const desc = document.createElement('p');
        desc.textContent = project.description;
        
        card.appendChild(title);
        card.appendChild(desc);
        container.appendChild(card);
    });
}

// Add header-related functionality
function setupHeaderEffects() {
    // Adjust header to accommodate the category filters
    const style = document.createElement('style');
    style.textContent = `
        /* PREVENT ALL HEADER ANIMATIONS */
        .fixed-header, .fixed-header *, 
        .header-title, .header-subtitle, 
        .header-left, .header-right,
        .header-left *, .header-right * {
            transition: none !important;
            animation: none !important;
            transform: none !important;
            animation-delay: 0s !important;
            animation-duration: 0s !important;
            transition-delay: 0s !important;
            transition-duration: 0s !important;
            opacity: 1 !important;
        }
        
        /* DISABLE SCROLLED STATE EFFECTS */
        .fixed-header.scrolled {
            /* Prevent any background color changes */
            background-color: rgba(10, 10, 10, 0.95) !important;
            /* Prevent box-shadow changes */
            box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5) !important;
        }
        
        /* DISABLE TITLE/SUBTITLE CHANGES */
        .fixed-header.scrolled .header-title {
            /* Keep font size constant */
            font-size: 28px !important;
        }
        
        .fixed-header.scrolled .header-subtitle {
            /* Keep visible */
            opacity: 1 !important;
        }
        
        /* DISABLE HEIGHT CHANGES AND ADJUST FOR CATEGORY MENU */
        .fixed-header, .fixed-header.scrolled {
            height: 140px !important; /* Increased to accommodate category menu */
            position: relative !important;
        }
        
        .fixed-header .header-content {
            position: relative;
            top: 0;
            padding-bottom: 45px; /* Make room for filters */
        }
        
        /* DESKTOP ADJUSTMENT POINT: Adjust this value to move the PORTFOLIO text up/down on desktop */
        .fixed-header .header-title,
        .header-title {
            padding-top: 0 !important;
            margin-top: -3px !important; /* TUNE THIS VALUE for desktop alignment - negative values move text UP */
        }
        
        /* CRITICAL: Ensure the hamburger menu is always visible */
        .mobile-menu-button, 
        .header-right,
        .fixed-header .header-right,
        .fixed-header .mobile-menu-button {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            z-index: 999999 !important;
            pointer-events: auto !important;
        }
        
        /* Position the header right consistently */
        .header-right,
        .fixed-header .header-right {
            position: absolute !important;
            right: 20px !important;
            top: 15px !important; /* Desktop position - UNCHANGED */
        }
        
        @media (max-width: 800px) {
            .fixed-header, .fixed-header.scrolled {
                height: 145px !important; /* Increased height to accommodate taller selection menu */
                padding-top: 0px !important; /* Removed top padding */
            }
            
            .fixed-header .header-content {
                padding-top: 0px !important; /* No top padding */
                padding-bottom: 55px !important; /* Increased to make room for the taller selection menu */
            }
            
            /* MOBILE ADJUSTMENT POINT 2: Adjust this value to move the PORTFOLIO text up/down on mobile */
            .fixed-header .header-title {
                padding-top: 0 !important;
                margin-top: 2px !important; /* TUNE THIS VALUE for mobile alignment */
                line-height: 1.2 !important;
            }
            
            /* Position the header right on mobile to match home page */
            .header-right,
            .fixed-header .header-right,
            .mobile-menu-button,
            .fixed-header .mobile-menu-button {
                top: 20px !important; /* Unchanged - this position is correct */
            }
            
            .category-filters {
                flex-wrap: wrap;
                gap: 12px !important; /* Increased for more space between filter buttons */
                padding: 10px 0 !important; /* Increased vertical padding (1.5x) */
                position: absolute !important;
                bottom: 0 !important;
                left: 0 !important;
                width: 100% !important;
                z-index: 100 !important;
            }
            
            .category-filter {
                padding: 6px 12px !important; /* Increased padding for taller/wider buttons (1.5x) */
                font-size: 12px !important; /* Slightly larger text for better readability */
            }
        }
        
        /* Additional adjustments for very small screens */
        @media (max-width: 480px) {
            .fixed-header, .fixed-header.scrolled {
                height: 145px !important; /* Match the new mobile height */
                padding-top: 0px !important;
            }
            
            .fixed-header .header-content {
                padding-top: 0px !important;
                padding-bottom: 55px !important; /* Match the new mobile padding */
            }
            
            /* MOBILE ADJUSTMENT POINT 3: Adjust this value to move the PORTFOLIO text up/down on very small mobile */
            .fixed-header .header-title {
                padding-top: 0 !important;
                margin-top: 2px !important; /* TUNE THIS VALUE for small mobile alignment */
            }
        }
    `;
    document.head.appendChild(style);
    
    // REMOVE all scroll listeners that might be affecting the header
    const container = document.querySelector('.container');
    if (container) {
        // Create a replacement scroll listener that does nothing with the header
        // but keeps any other necessary scroll functionality
        const originalAddEventListener = container.addEventListener;
        container.addEventListener = function(type, listener, options) {
            if (type === 'scroll') {
                // Replace scroll listeners with empty function to prevent header changes
                return originalAddEventListener.call(this, type, function(e) {
                    // Do nothing with the header
                }, options);
            }
            return originalAddEventListener.call(this, type, listener, options);
        };
    }
    
    // Remove the scrolled class from header if it exists
    const header = document.querySelector('.fixed-header');
    if (header) {
        header.classList.remove('scrolled');
        
        // Force consistent height
        header.style.height = window.innerWidth > 800 ? '140px' : '160px';
        
        // Remove any inline transitions
        header.style.transition = 'none';
        
        // Block any attempt to add the scrolled class
        const originalClassListAdd = header.classList.add;
        header.classList.add = function(...args) {
            // Filter out 'scrolled' from arguments
            const filteredArgs = args.filter(arg => arg !== 'scrolled');
            if (filteredArgs.length > 0) {
                return originalClassListAdd.apply(this, filteredArgs);
            }
        };
    }
    
    // Make sure the hamburger menu is visible immediately
    const ensureMenuVisible = () => {
        const menuButton = document.querySelector('.mobile-menu-button');
        const headerRight = document.querySelector('.header-right');
        
        if (menuButton) {
            menuButton.style.display = 'block';
            menuButton.style.visibility = 'visible';
            menuButton.style.opacity = '1';
            menuButton.style.zIndex = '999999';
            menuButton.style.pointerEvents = 'auto';
            
            // Adjust position on mobile to match home page
            if (window.innerWidth <= 800) {
                menuButton.style.top = '20px';
            } else {
                menuButton.style.top = '15px'; // Unchanged for desktop
            }
        }
        
        if (headerRight) {
            headerRight.style.display = 'block';
            headerRight.style.visibility = 'visible';
            headerRight.style.opacity = '1';
            headerRight.style.position = 'absolute';
            headerRight.style.right = '20px';
            
            // Adjust position on mobile to match home page
            if (window.innerWidth <= 800) {
                headerRight.style.top = '20px';
            } else {
                headerRight.style.top = '15px'; // Unchanged for desktop
            }
            
            headerRight.style.pointerEvents = 'auto';
        }
    };
    
    // Run the function immediately and after a delay
    ensureMenuVisible();
    setTimeout(ensureMenuVisible, 100);
    setTimeout(ensureMenuVisible, 500);
    
    // Handle resize events
    window.addEventListener('resize', ensureMenuVisible);
}

// CRITICAL FIX: Prevent any code from modifying the container's scrollbar
document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.container');
    if (container) {
        // Store original styles
        const originalStyle = {
            position: container.style.position,
            top: container.style.top,
            height: container.style.height,
            overflowY: container.style.overflowY
        };
        
        // Override setProperty/style to prevent changes to critical properties
        const originalSetProperty = CSSStyleDeclaration.prototype.setProperty;
        CSSStyleDeclaration.prototype.setProperty = function(prop, value) {
            if (this === container.style) {
                if (prop === 'position' || prop === 'top' || prop === 'height' || 
                    prop === 'bottom' || prop === 'overflow' || prop === 'overflow-y') {
                    console.log('Prevented style change:', prop, value);
                    return;
                }
            }
            return originalSetProperty.call(this, prop, value);
        };
        
        // Override direct style assignment
        Object.defineProperties(container.style, {
            position: {
                get: function() { return originalStyle.position || 'absolute'; },
                set: function() { console.log('Prevented position style change'); }
            },
            top: {
                get: function() { return originalStyle.top || '100px'; },
                set: function() { console.log('Prevented top style change'); }
            },
            height: {
                get: function() { return originalStyle.height || 'calc(100% - 100px)'; },
                set: function() { console.log('Prevented height style change'); }
            },
            overflowY: {
                get: function() { return originalStyle.overflowY || 'auto'; },
                set: function() { console.log('Prevented overflow-y style change'); }
            },
            overflow: {
                get: function() { return 'auto'; },
                set: function() { console.log('Prevented overflow style change'); }
            }
        });
    }
});

// Create category filters function (separated from addCategoryFilters)
function createCategoryFilters(filtersContainer) {
    // Get unique categories from the portfolio data
    const uniqueCategories = [...new Set(portfolioData.map(project => project.category))];
    const categories = ['All', ...uniqueCategories];
    
    // Create a filter button for each category
    categories.forEach(category => {
        const filterButton = document.createElement('div');
        filterButton.className = 'category-filter';
        filterButton.dataset.category = category;
        filterButton.textContent = category;
        
        // Set 'All' as active by default
        if (category === 'All') {
            filterButton.classList.add('active');
        }
        
        // Add click event for filtering
        filterButton.addEventListener('click', () => {
            // Update active state
            document.querySelectorAll('.category-filter').forEach(btn => {
                btn.classList.remove('active');
            });
            filterButton.classList.add('active');
            
            // Filter projects
            filterProjects(category);
        });
        
        filtersContainer.appendChild(filterButton);
    });
}

// Filter projects based on selected category
function filterProjects(category) {
    console.log('Filtering by category:', category);
    
    // Get visible projects based on category
    let visibleProjects;
    if (category === 'All') {
        visibleProjects = [...portfolioData]; // Create a copy to avoid modifying the original
    } else {
        visibleProjects = portfolioData.filter(project => project.category === category);
    }
    
    // Ensure projects are sorted by order
    visibleProjects.sort((a, b) => a.order - b.order);
    
    // Get the container
    const container = document.getElementById('scene-container');
    if (!container) return;
    
    // Add filtering class to prevent animation glitches
    container.classList.add('filtering');
    
    // Get or create masonry container
    let masonryContainer = container.querySelector('.masonry-container');
    if (!masonryContainer) {
        masonryContainer = document.createElement('div');
        masonryContainer.className = 'masonry-container';
        container.appendChild(masonryContainer);
    }
    
    // Clear existing content
    masonryContainer.innerHTML = '';
    
    // Create cards for filtered projects
    visibleProjects.forEach((project, index) => {
        createProjectCard(project, index, masonryContainer);
    });
    
    // Initialize masonry layout immediately
    initMasonryLayout();
    
    // Remove filtering class after layout has settled
    setTimeout(() => {
        container.classList.remove('filtering');
    }, 100);
}

// Create category tag styling
const categoryTagStyles = `
    /* Base category tag style */
    .category-tag {
        padding: 4px 10px;
        border-radius: 4px;
        color: white;
        font-family: 'Montserrat', sans-serif;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        display: inline-block;
        margin-top: 10px;
    }
    
    /* Category-specific tag styles */
`;

// Generate category-specific tag styles
let categoryTagStylesContent = categoryTagStyles;
for (const category in categoryColors) {
    if (category !== 'default') {
        categoryTagStylesContent += `
            .category-tag[data-category="${category}"] {
                background-color: transparent;
                border: 1px solid ${categoryColors[category].gradient[0]};
                color: ${categoryColors[category].gradient[0]};
            }
        `;
    }
}

// Add the category tag styles to the document
const categoryTagStyleElement = document.createElement('style');
categoryTagStyleElement.id = 'category-tag-styles';
categoryTagStyleElement.textContent = categoryTagStylesContent;
document.head.appendChild(categoryTagStyleElement); 

// Add styles for fullscreen image viewer
const fullscreenImageStyles = document.createElement('style');
fullscreenImageStyles.id = 'fullscreen-image-styles';
fullscreenImageStyles.textContent = `
    .fullscreen-image-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.95);
        z-index: 2000000;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
        backdrop-filter: blur(10px);
    }

    .fullscreen-image-overlay.active {
        opacity: 1;
        pointer-events: auto;
    }

    .fullscreen-image-overlay img {
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
        border-radius: 4px;
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.7);
        transform: scale(0.95);
        transition: transform 0.3s ease;
    }

    .fullscreen-image-overlay.active img {
        transform: scale(1);
    }

    .fullscreen-image-close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: rgba(60, 60, 60, 0.7);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.3s ease, transform 0.3s ease;
    }

    .fullscreen-image-close:hover {
        background-color: rgba(80, 80, 80, 0.9);
        transform: rotate(90deg);
    }

    .fullscreen-image-close::before,
    .fullscreen-image-close::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 2px;
        background-color: white;
    }

    .fullscreen-image-close::before {
        transform: rotate(45deg);
    }

    .fullscreen-image-close::after {
        transform: rotate(-45deg);
    }
`;
document.head.appendChild(fullscreenImageStyles);